/* eslint-disable no-console */
import Vuex from 'vuex'
import Vue from 'vue'
import firebase from "firebase/app"
import "firebase/firestore"
import {
  vuexfireMutations,
  firestoreAction,
} from 'vuexfire';
import firebaseConfig from './firebase-config';

firebase.initializeApp(firebaseConfig);
const db = firebase.firestore();

const documentName = '2019';
const siteDataRef = db.collection('site-data').doc(documentName);
const menuListRef = db.collection('menuList');
const subMenuListRef = db.collection('subMenuList');
const slideListRef = db.collection('slideList');
const updateInfoListRef = db.collection('updateInfoList');
const contentListHomeRef = db.collection('contentListHome');
const contentListPerformanceRef = db.collection('contentListPerformance');
const contentListPastPerformanceRef = db.collection('contentListPastPerformance');
const contentListAboutRef = db.collection('contentListAbout');
const contentListJoinUsRef = db.collection('contentListJoinus');
const contentListBlogRef = db.collection('contentListBlog');

const contentListContactRef = db.collection('contentListContact');
const creditListRef = db.collection('creditList');

const blogPostsRef = db.collection('fl_content').where('_fl_meta_.schema', '==', 'blog').where('status', '==', 'published');

Vue.use(Vuex)

const INIT_DATA = 'INIT_DATA';
const INIT_ITEM = 'INIT_ITEM';
const myPlugin = store => store.dispatch(INIT_DATA, 'test');

export default new Vuex.Store({
  // strict: process.env.NODE_ENV !== 'production',
  unsubscribe: null,
  state: {
    siteData: [],
    menuList: [],
    subMenuList: [],
    slideList: [],
    updateInfoList: [],
    contentListHome: [],
    contentListPerformance: [],
    contentListPastPerformance: [],
    contentListAbout: [],
    contentListJoinUs: [],
    contentListBlog: [],
    contentListContact: [],
    creditList: [],
    blogPosts: [],
  },
  modules: {
    common: {
      namespaced: true,
      state: {
        pageTitle: 'たちかわ演劇祭',
      },
      actions: {
        changePage({ commit }, title) {
          commit('cahgePageTitle', title);
        },
      },
      mutations: {
        cahgePageTitle(state, title) {
          const st = state;
          st.pageTitle = title;
        },
      },
      getters: {
        pageTitle(state) {
          const st = state;
          return st.pageTitle;
        },
      },
    },
  },
  mutations: {
    ...vuexfireMutations,
    [INIT_ITEM] (state, payload) {
      state.data = payload
    },
  },
  actions: {
    [INIT_DATA]: firestoreAction(({
      bindFirestoreRef
    }) => {
      bindFirestoreRef('siteData', siteDataRef, {
        wait: true
      });
      bindFirestoreRef('menuList', menuListRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('subMenuList', subMenuListRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('slideList', slideListRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('updateInfoList', updateInfoListRef.orderBy('date'), {
        wait: true
      });
      bindFirestoreRef('contentListHome', contentListHomeRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('contentListPerformance', contentListPerformanceRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('contentListPastPerformance', contentListPastPerformanceRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('contentListAbout', contentListAboutRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('contentListJoinUs', contentListJoinUsRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('contentListBlog', contentListBlogRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('contentListContact', contentListContactRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('creditList', creditListRef.orderBy('no'), {
        wait: true
      });
      bindFirestoreRef('blogPosts', blogPostsRef.orderBy('date', 'desc'), {
        wait: true
      }).then(() => {
        // console.log('blogPostsRef Loaded');
      }).catch(err => {
        console.log(err)
      });
    }),
  },
  getters: {
    getSiteData: state => state.siteData,
    getMenuList: state => state.menuList,
    getSubMenuList: state => state.subMenuList,
    getSlideList: state => state.slideList,
    getUpdateInfoList: state => state.updateInfoList,
    getContentListHome: state => state.contentListHome,
    getContentListPerformance: state => state.contentListPerformance,
    getContentListPastPerformance: state => state.contentListPastPerformance,
    getContentListAbout: state => state.contentListAbout,
    getContentListJoinUs: state => state.contentListJoinUs,
    getContentListBlog: state => state.contentListBlog,
    getContentListContact: state => state.contentListContact,
    getCreditList: state => state.creditList,
    getBlogPosts: state => state.blogPosts,
    data (state) {
      return state.data
    },
  },
  plugins: [myPlugin],
})
